<app-new-purchase-upgrades></app-new-purchase-upgrades>